import { Component, Inject, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatLegacyPaginator as MatPaginator } from '@angular/material/legacy-paginator';
import {
	POPULATE_FOR_THIS_ACCOUNT_ATTRIBUTE,
	RECENT_TRANSACTIONS_TABLE,
	RecentTransactionsTable,
	RestService,
	TransactionDTO,
} from 'cargo-chief-commons';
import { UrlService } from '@service/url/url.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { environment } from '@environment/environment';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { SegmentEventsConstants } from '@domain/constants/segment-events-constants';
import { SORT_BY_KEY } from '@domain/constants/functions';
import { RECENT_TRANSACTION_SORT } from '@domain/constants/app-variables';

@Component({
	selector: 'app-recent-transactions-dialog',
	templateUrl: 'recent-transactions-dialog.html',
	styleUrls: ['./recent-transactions-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class RecentTransactionsDialogComponent implements OnInit {
	recentTransactionsTable: Array<RecentTransactionsTable> = [];

	agedTransactionCount: boolean = false;
	totalTransactions: number = 0;
	maxTotalTransactions: number = 100;
	pageSize: number = 10;
	isLoading = false;
	recentTransactionsDataTable = new MatTableDataSource<RecentTransactionsTable>([]);
	@ViewChild(MatPaginator) paginator: MatPaginator;

	displayedColumns = [
		// 'age',
		'pickupDate',
		'origin',
		'destination',
		'trailerType',
		'allInCost',
		'LoH',
		'pricePerMile',
		'deadheadDiff',
	];

	constructor(
		public dialogRef: MatDialogRef<RecentTransactionsDialogComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			transactions: Array<TransactionDTO>;
			searchTruckForm: any;
			accountId: number;
			recentTransactionsCount: number;
			agedTransactionCount: boolean;
		},
		private urlService: UrlService,
		private restService: RestService,
		private utilService: UtilService,
		private segmentWrapper: SegmentWrapperService
	) {
		this.agedTransactionCount = this.data.agedTransactionCount;
		this.totalTransactions = this.data.recentTransactionsCount > this.maxTotalTransactions ?
			this.maxTotalTransactions : this.data.recentTransactionsCount;
	}

	ngOnInit() { }

	ngAfterViewInit() {
		this.setPaginator();
		this.getRecentTransactions();
	}

	getRecentTransactions() {
		this.isLoading = true;
		const url = this.urlService.getRecentTransactions(0, this.maxTotalTransactions);
		let payload = this.data.searchTruckForm;
		if (this.data.agedTransactionCount) {
			payload = { ...payload, age: environment.RECENT_TRANSACTION_AGE };
		}
		this.restService.POST(url, payload).subscribe(
			(result) => {
				let newChunk = result.data;
				if (newChunk.length > 0) {
					let existingTransactions = this.data.transactions?.map((transaction) => transaction.id) || [];
					let newTransactions: Array<TransactionDTO> = newChunk.filter(
						(transaction) => !existingTransactions.includes(transaction.id)
					);
					newTransactions = POPULATE_FOR_THIS_ACCOUNT_ATTRIBUTE(
						newTransactions,
						this.data.accountId
					);
					this.recentTransactionsTable = [
						...this.recentTransactionsTable,
						...RECENT_TRANSACTIONS_TABLE(newTransactions),
					];
					this.recentTransactionsDataTable = new MatTableDataSource<RecentTransactionsTable>(
						SORT_BY_KEY(this.recentTransactionsTable, RECENT_TRANSACTION_SORT.DEADHEAD_DIFF)
					);
					this.setPaginator();
				}
				this.fireSegmentEvent();
				this.isLoading = false;
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to load Recent Transactions.',
					SNACKBAR.WARNING,
					SNACKBAR.ACTION
				);
				this.isLoading = false;
			}
		);
	}

	closeDialog() {
		this.dialogRef.close();
	}

	setPaginator() {
		this.recentTransactionsDataTable.paginator = this.paginator;
		this.paginator.pageSize = this.pageSize;
	}

	fireSegmentEvent() {
		const payload = {
			user: this.utilService.getUserDataForSegmentEvent(),
			search: this.data.searchTruckForm,
			recentTransactionsCount: this.recentTransactionsTable.length,
		};
		this.segmentWrapper.fireSegmentEvent(
			SegmentEventsConstants.user_viewed_recent_transaction_details,
			payload
		);
	}
}
